import React from 'react';

export default function Footer() {
    return (
        <div className="app-footer">
            <div className="px-3">
                <div className="col"></div>
                <div className="col text-end">
                    Copyright &copy; {new Date().getFullYear()}, Dave Rodriguez
                </div>
            </div>
        </div>
    )
}